module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ack",
      "epub:type": "acknowledgments",
      "role": "doc-acknowledgments"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "h1",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page xiii. ",
      "epub:type": "pagebreak",
      "id": "page_xiii",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I am grateful to have been able to work on this book on the unceded traditional territory of the Snuneymuxw First Nation, who have lived in this region for many thousands of years, and whose lifestyles did not result in significant changes to the land or to the precious Salish Sea surrounding it, and who did not do things that could lead to changes to the climate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am also grateful to Isaac, Tim, Heather, and Justine for your valuable feedback on various parts of the manuscript, and to thousands of students for letting me be your guide along the rocky and sometimes fog-shrouded paths of earth science, and for all of your great questions and insights."), _c('span', {
    attrs: {
      "aria-label": " Page xiv. ",
      "epub:type": "pagebreak",
      "id": "page_xiv",
      "role": "doc-pagebreak"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a25ac4ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 75
// module chunks = 0